import { c as _c } from "react/compiler-runtime";
import type { CreditCardOffer } from '@cc-shopping/contracts/compare/schema/types';
import { useStrictContext } from '@cc-shopping/hooks/useStrictContext';
import type { SkuViewedPayload } from '@cc-shopping/platform-analytics/Shibuya';
import { FinishType } from '@cc-shopping/platform-analytics/types';
import { createContext, type PropsWithChildren } from 'react';
import type { CtaAnalyticsProps } from 'src/features/product-card/CTA/CtaLink';
export type CompareAnalytics = CtaAnalyticsProps & {
  marketplacePayload: NonNullable<Required<CtaAnalyticsProps['marketplacePayload']>> & {
    monetizable: Required<SkuViewedPayload>['monetizable'];
  };
};
type CreditCardCompareOfferContextValue = {
  offer: CreditCardOffer;
  analytics: CompareAnalytics;
};
const CreditCardCompareOfferContext = createContext<CreditCardCompareOfferContextValue | null>(null);
type CreditCardCompareOfferContextProviderProps = {
  offer: CreditCardOffer;
  index: number;
};
export function CreditCardCompareOfferContextProvider(t0) {
  const $ = _c(21);
  const {
    children,
    offer,
    index
  } = t0;
  const {
    analyticsProps: t1,
    cta,
    monetizable,
    product,
    productType
  } = offer;
  const {
    institutionId
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      name: "cc_compare_grid",
      position: undefined
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== cta.link || $[2] !== index || $[3] !== institutionId || $[4] !== monetizable || $[5] !== offer.id || $[6] !== product.id || $[7] !== productType) {
    t3 = {
      destination_url: cta.link,
      element_position: index,
      marketplace_product_type: productType,
      marketplace_institution_id: institutionId,
      marketplace_product_id: product.id,
      marketplace_offer_id: offer.id,
      monetizable,
      section_position: 0,
      section_name: "cc_compare_grid"
    };
    $[1] = cta.link;
    $[2] = index;
    $[3] = institutionId;
    $[4] = monetizable;
    $[5] = offer.id;
    $[6] = product.id;
    $[7] = productType;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = monetizable === "no" ? FinishType.InternalContent : FinishType.ExternalApplication;
  let t5;
  if ($[9] !== index || $[10] !== monetizable || $[11] !== product.id || $[12] !== t3 || $[13] !== t4) {
    t5 = {
      entityId: product.id,
      monetizable,
      productPosition: index,
      section: t2,
      marketplacePayload: t3,
      finishType: t4
    };
    $[9] = index;
    $[10] = monetizable;
    $[11] = product.id;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const analytics = t5;
  let t6;
  if ($[15] !== analytics || $[16] !== offer) {
    t6 = {
      offer,
      analytics
    };
    $[15] = analytics;
    $[16] = offer;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== children || $[19] !== t6) {
    t7 = <CreditCardCompareOfferContext.Provider value={t6}>{children}</CreditCardCompareOfferContext.Provider>;
    $[18] = children;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}
export function useCreditCardCompareOfferContext() {
  const creditCardCompareColumnContext = useStrictContext(CreditCardCompareOfferContext);
  return creditCardCompareColumnContext;
}